import { render, staticRenderFns } from "./DeviceSelector.vue?vue&type=template&id=196b60d9"
import script from "./DeviceSelector.vue?vue&type=script&lang=js"
export * from "./DeviceSelector.vue?vue&type=script&lang=js"
import style0 from "./DeviceSelector.vue?vue&type=style&index=0&id=196b60d9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports